import { graphql } from 'gatsby'
import ContactPage from '../views/contactUs'

export default ContactPage
export const query = graphql`
  query ComplaintsQuery($slug: String, $locale: String) {
    header: contentfulHeader(node_locale: { eq: $locale }) {
      ...headerFragment
    }
    footer: contentfulFooter(node_locale: { eq: $locale }) {
      ...footerFragment
    }
    waitingList: contentfulCtaSection(
      page: { elemMatch: { node_locale: { eq: $locale }, slug: { eq: $slug } } }
    ) {
      ...waitingListFragment
    }
    hero: contentfulHeroSection(
      page: { elemMatch: { node_locale: { eq: $locale }, slug: { eq: $slug } } }
    ) {
      ...heroFragment
    }
    page: contentfulPage(slug: { eq: $slug }, node_locale: { eq: $locale }) {
      feature: pageSection {
        ... on ContentfulSectionText {
          id
          title
          sectionText {
            raw
          }
          link {
            to: link
            text: title
          }
          form {
            ...pageFormFragment
          }
        }
        ...contactChannelsFragment
      }
      metaDescription
      metaTag
      title
      slug
    }
  }
`
